import { MapboxOptions } from 'mapbox-gl';

export const defaultConfiguration: MapboxOptions & {
    sourceId: string;
    layerId: string;
    iconKey: string;
    activeIconKey: string;
    server_uri: string;
} = Object.freeze({
    container: 'map',
    sourceId: 'mapGeoSource',
    layerId: 'mapGeoLayer',
    iconKey: 'mapIconKey',
    activeIconKey: 'mapActiveIconKey',
    // Denmark
    zoom: 6.2,
    center: [11.166863432084483, 56.0865080288055],
    server_uri: 'https://bogogide.controlpanel.viamap.net',
});

export const mapInitconfiguration: Pick<MapboxOptions, 'accessToken' | 'style'> = Object.freeze({
    accessToken: `${process.env.VIAMAP_TOKEN}` || '',
    style: `https://bogogide.tiles.viamap.net/v1/style.json?token=${process.env.VIAMAP_TOKEN}` || '',
});

export const viaMapConfig = Object.freeze({
    strapScriptUrl: `${defaultConfiguration.server_uri}/v1/js/viamapstrap.js`,
});

export const messages = Object.freeze({
    updateLayoutPropertiesError:
        'Map error - Tried to update layout with missing id or active marker image please supply that got: ',
    imageLoadError: 'Map error - Tried to load image but got error: ',
});
